import "vendor/jquery.mark.js";

import search from "components/search";

$(() => {
  search();
});
